import { render, staticRenderFns } from "./CostiPerRicaviListTable.vue?vue&type=template&id=08d561e1&"
import script from "./CostiPerRicaviListTable.vue?vue&type=script&lang=js&"
export * from "./CostiPerRicaviListTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports